import { jwtDecode } from "jwt-decode";

import {
  MILLISECONDS_IN_SECOND,
  TOKEN_REFRESH_MARGIN_SECONDS,
} from "../../constants";
import { IJwtPayload } from "../../models";
import {
  isLocalOrJenkinsModeOrQsDebugLog,
  isTokenInfoLoggingMode,
} from "../env.helpers";
import { Log } from "../log.helpers";

export const logTokenExpiration = (
  accessToken: string | null | undefined,
  logAddInfo?: string,
): void => {
  if (!isLocalOrJenkinsModeOrQsDebugLog()) {
    return;
  }

  if (!accessToken) {
    Log.debug("No token");
    return;
  }

  const { exp } = jwtDecode<IJwtPayload>(accessToken);

  if (!exp) {
    Log.debug("Bad token");
    return;
  }

  const now = Date.now() / MILLISECONDS_IN_SECOND;
  const rem = Math.max(0, Math.round(exp - now));
  const willRefreshIn = Math.max(0, rem - TOKEN_REFRESH_MARGIN_SECONDS);

  if (isTokenInfoLoggingMode()) {
    Log.debug(
      `[ACCESS TOKEN${logAddInfo ? "-" + logAddInfo : ""}] expiration at: ${new Date(exp * MILLISECONDS_IN_SECOND).toLocaleTimeString()} (in ${rem}s), will be attempted to refresh in: ${willRefreshIn}s}`,
    );
  }
};

export const logRefreshTokenExpiration = (
  refreshToken: string | null | undefined,
): void => {
  if (!isLocalOrJenkinsModeOrQsDebugLog()) {
    return;
  }

  if (!refreshToken) {
    Log.debug("No token");
    return;
  }

  const { exp } = jwtDecode<IJwtPayload>(refreshToken);

  if (!exp) {
    Log.debug("Bad refresh token");
    return;
  }

  const now = Date.now() / MILLISECONDS_IN_SECOND;
  const rem = Math.max(0, Math.round(exp - now));

  if (isTokenInfoLoggingMode()) {
    Log.log(
      `[REFRESH TOKEN] expiration at: ${new Date(exp * MILLISECONDS_IN_SECOND).toLocaleTimeString()} (in ${rem}s)`,
    );
  }
};
